import { render, staticRenderFns } from "./RewardPane.vue?vue&type=template&id=0c2a1cb5&scoped=true"
import script from "./RewardPane.vue?vue&type=script&lang=ts"
export * from "./RewardPane.vue?vue&type=script&lang=ts"
import style0 from "./RewardPane.vue?vue&type=style&index=0&id=0c2a1cb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2a1cb5",
  null
  
)

export default component.exports